module.exports = __webpack_public_path__ + "static/writing-business-software.ff5dba89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/writing-business-software.jpg
// module id = 502
// module chunks = 35783957827783